import {FC, useRef, useState} from 'react'
import {getInterestIcon} from 'features/interests/helper'
import {names} from 'shared/lib'
import {scrollToTop} from 'shared/lib/scroll-to'
import {InterestCategory} from 'shared/types'
import {Button} from 'shared/ui/buttons'
import {Check} from 'shared/ui/icons'
import styles from './styles.module.scss'

type InterestsSelectProps = {
  interestCategories: InterestCategory[]
  selectedInterestsIds: number[]
  onChangeInterest: (id: number) => void
}

export const InterestsSelect: FC<InterestsSelectProps> = ({
  interestCategories,
  selectedInterestsIds,
  onChangeInterest
}) => {
  const [selectedSidebarItem, setSelectedSidebarItem] = useState(interestCategories[0])
  const ref = useRef<HTMLDivElement | null>(null)

  if (!interestCategories.length) return <></>

  return (
    <div className={styles.interestsSelect}>
      <div className={names(styles.sidebar, styles.customScroll)}>
        {interestCategories.map((category) => (
          <div
            key={category.name}
            className={names(
              styles.sidebarItem,
              category.name === selectedSidebarItem.name && styles.active
            )}
            onClick={() => {
              setSelectedSidebarItem(category)
              scrollToTop(ref)
            }}
          >
            <div className={styles.sidebarItemIcon}>{getInterestIcon(category.name)}</div>
            <span className={styles.sidebarItemText}>{category.name}</span>
            <span className={styles.sidebarItemNotice}>
              {category.interests.filter((item) => selectedInterestsIds.includes(item.id)).length || ''}
            </span>
          </div>
        ))}
      </div>
      <div className={names(styles.content, styles.customScroll)} ref={ref}>
        {selectedSidebarItem.interests.map((interest) => (
          <Button
            key={interest.id}
            styleType='outlinedGray'
            className={names(
              styles.contentItem,
              selectedInterestsIds.includes(interest.id) && styles.active
            )}
            onClick={() => onChangeInterest(interest.id)}
          >
            {selectedInterestsIds.includes(interest.id) && (<Check />)}
            {interest.name}
          </Button>
        ))}
      </div>
    </div>
  )
}
